import React from "react"
import { useTheme } from "react-jss"
import { useTranslation } from "react-i18next"
import classNames from 'classnames'

import { ContentBox } from '@portal/kit/pkg/components'

import styles from './styles'


export default function OutOfNetworkMessage() {
  const theme = useTheme()
  const { t } = useTranslation()
  const classes = styles(theme)

  return (
    <ContentBox title={t('internet_access.my_internet_access')} titleIcon="wifi">
      <p className={classes.internetAccessText}>
        <span className={classNames('fal', 'fa-times-circle', classes.internetAccessIcon)} />
        {t('internet_access.out_of_wifirst_network')}
      </p>
    </ContentBox>
  )
}
